import React, { Fragment, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import { hasMultipleSupport, isSS } from "../store/info";
import {
  SafetyWizardPage,
  ProtectionChoicePage,
  MultipleWizardProfilesPage,
  SingleWizardPage,
} from "../pages/wizard";
import {
  MultipleWizardDevicesPage,
  MultipleWizardProtectionPage,
} from "../pages/wizard/multiple";
import { MultipleWizardPage } from "../pages/wizard/multiple/MultipleWizardPage";
import { isSavedProfiles } from "../pages/wizard/store/wizard.selectors";
import { Protection } from "../pages/wizard/store/wizard.actions";

export const WizardPaths = {
  ProtectionChoice: "/wizard/protection-choice",
  Single: "/wizard/single",
  Multiple: "/wizard/multiple",
  Protection: "/wizard/multiple/protection",
  Devices: "/wizard/multiple/devices",
};

export const MultipleNavigationChain = [
  WizardPaths.Multiple,
  WizardPaths.Protection,
  WizardPaths.Devices,
];

const SubscriberSafety = () => (
  <Routes>
    <Route path={"/wizard/safety"} element={<SafetyWizardPage />} />
    <Route path="*" element={<Navigate to="/wizard/safety" />} />
  </Routes>
);

const WizardRedirect = ({ hasSavedProfiles }) => {
  return hasSavedProfiles ? (
    <Navigate to={WizardPaths.Multiple} />
  ) : (
    <Navigate to={WizardPaths.ProtectionChoice} />
  );
};

const MultipleWizardRouter = ({ hasSavedProfiles }) => (
  <Routes>
    <Route path="/" element={<MultipleWizardPage />}>
      <Route index element={<MultipleWizardProfilesPage />} />
      {hasSavedProfiles && (
        <Fragment>
          <Route path="protection" element={<MultipleWizardProtectionPage />} />
          <Route path="devices" element={<MultipleWizardDevicesPage />} />
        </Fragment>
      )}
      <Route
        path="*"
        element={<WizardRedirect hasSavedProfiles={hasSavedProfiles} />}
      />
    </Route>
  </Routes>
);

const Wizard = ({ isMultipleSupported }) => {
  const [protection, setProtection] = useState(null);
  const hasSavedProfiles = useSelector(isSavedProfiles);

  return (
    <Routes>
      {!hasSavedProfiles && (
        <Route
          path="wizard/protection-choice"
          element={
            <ProtectionChoicePage
              choseProtection={setProtection}
              hasMultipleSupport={isMultipleSupported}
            />
          }
        />
      )}
      {protection === Protection.Single && (
        <Route path="wizard/single" element={<SingleWizardPage />} />
      )}
      {protection === Protection.Multiple && (
        <Route
          path="wizard/multiple/*"
          element={<MultipleWizardRouter hasSavedProfiles={hasSavedProfiles} />}
        />
      )}
      <Route
        path="*"
        element={<WizardRedirect hasSavedProfiles={hasSavedProfiles} />}
      />
    </Routes>
  );
};

export const WizardRouter = () => {
  const isSafety = useSelector(isSS);
  const isMultipleSupported = useSelector(hasMultipleSupport);

  return isSafety ? (
    <SubscriberSafety />
  ) : (
    <Wizard isMultipleSupported={isMultipleSupported} />
  );
};
